import { selectSliceCisview } from '../../selectors/HELPERS';
import { ROOT_SLICE } from './constants';

import { EMPTY_ARRAY } from '../../../components/utils/sync';

const EMPTY_OBJECT = [];

const isCisviewState = state => {
	const keyMap = Object.keys(state).reduce((acc, k) => {
		acc[k] = true;
		return acc;
	}, {});

	const checkForKeys = [ROOT_SLICE];
	return checkForKeys.every(k => keyMap[k]);
};

export const selectRootSlice = state => {
	const sliceState = selectSliceCisview(state);
	if (isCisviewState(sliceState)) {
		return sliceState[ROOT_SLICE];
	}

	// assume local slice state;
	return sliceState;
};

// **********
// CORE
// **********

export const selectData = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { data } = slice;
	return data;
};

export const selectDataByCustomer = (stateAdmin, { customer }) => {
	const data = selectData(stateAdmin);
	return data[customer] || EMPTY_ARRAY;
};

export const selectIsLoading = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { isLoading } = slice;
	return isLoading;
};

export const selectIsLoaded = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { isLoaded } = slice;
	return isLoaded;
};

export const selectErrorMessage = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { errorMessage } = slice;
	return errorMessage;
};

// **********
// MAPS
// **********

export const selectUseridMaps = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { useridMaps } = slice;
	return useridMaps;
};

export const selectUseridMapByCustomer = (stateAdmin, { customer }) => {
	const useridMaps = selectUseridMaps(stateAdmin);
	return useridMaps[customer] || EMPTY_OBJECT;
};

export const selectUserFullNameMaps = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { userFullNameMaps } = slice;
	return userFullNameMaps;
};

export const selectUserFullNameMapByCustomer = (stateAdmin, { customer }) => {
	const userFullNameMaps = selectUseridMaps(stateAdmin);
	return userFullNameMaps[customer] || EMPTY_OBJECT;
};

// **********
// VALIDATION
// **********

export const selectIsValidPm = (stateAdmin, { customer, userid, fullName }) => {
	const useridMap = selectUseridMapByCustomer(stateAdmin, { customer });
	const userFullNameMap = selectUserFullNameMapByCustomer(stateAdmin, {
		customer
	});
	return (
		(useridMap?.pms || {})[userid] ||
		(userFullNameMap?.pms || {})[fullName] ||
		false
	);
};

export const selectIsValidCt = (stateAdmin, { customer, userid, fullName }) => {
	const useridMap = selectUseridMapByCustomer(stateAdmin, { customer });
	const userFullNameMap = selectUserFullNameMapByCustomer(stateAdmin, {
		customer
	});
	return (
		(useridMap?.pms || {})[userid] ||
		(userFullNameMap?.pms || {})[fullName] ||
		false
	);
};

export default {
	selectData,
	selectDataByCustomer,
	selectIsLoading,
	selectIsLoaded,
	selectErrorMessage,

	selectUseridMaps,
	selectUseridMapByCustomer,
	selectUserFullNameMaps,
	selectUserFullNameMapByCustomer,

	selectIsValidPm,
	selectIsValidCt
};
